import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Pagination, ListGroup } from 'react-bootstrap';
import { Label, Icon } from 'semantic-ui-react';
import Spinner from '../../common/Spinner';
import TimeUtils from '../../../helper/TimeUtils';

import { setTableData } from '../../../actions/transOperationActions';

class Versions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      versions: null,
      loading: false,

      active: 1,
    };
    this.pageChanged = this.pageChanged.bind(this);
  }

  pageChanged(e) {
    this.setState({ active: parseFloat(e.target.text) });
  }

  async componentDidMount() {
    // {"tProjectDetial":430,"fId":21209,"saveDate":"/Date(1602212314000)/","email":"yang286a@gmail.com"}
    //利用fId 來反序

    var result = this.props.project.versions;
    function sortId(a, b) {
      return b.fId - a.fId;
    }
    result.sort(sortId);

    await this.setState({ versions: result });
  }

  async componentWillReceiveProps(nextProps) {
    await this.setState({ versions: nextProps.project.versions });
  }

  render() {
    const { versions, active } = this.state;

    let items = [];
    const totalPageNumber =
      versions === null ? 0 : Math.round(versions.length / 200);
    for (let number = 1; number <= totalPageNumber; number++) {
      items.push(
        <Pagination.Item key={number} active={number === active}>
          {number}
        </Pagination.Item>
      );
    }
    const paginationBasic = (
      <div>
        <Pagination onClick={this.pageChanged}>{items}</Pagination>
      </div>
    );

    //資料
    let versionsView;
    if (versions !== null) {
      versionsView = versions.map((request, index) => {
        if (index >= 200 * (active - 1) && index < 200 * active) {
          const { saveDate, fId, tProjectDetial, email } = request;

          // fId(pin):1
          // tProjectDetial(pin):2
          // jsonData(pin):"22"
          // saveDate(pin):"/Date(1578358860000)/"

          let saveDateString = `${TimeUtils.getDateFromDateString(saveDate)}`;

          let user_email = this.props.auth.user.email;

          let isAdmin = false;
          if (user_email.includes('thesubpro.com') === true) {
            //管理者 全部顯示
            isAdmin = true;
          }

          let emailObj = (
            <Label color='teal'>
              <Icon name='user outline' /> {email}
            </Label>
          );

          if (isAdmin === true) {
            //管理者
          } else {
            //一般用戶
            if (email === user_email) {
            } else {
              emailObj = null;
            }
          }

          const displayObj = (
            <ListGroup.Item>
              <a
                onClick={async () => {
                  await this.setState({ loading: true });
                  await this.props.loadFile(parseInt(fId, 10));
                  await this.setState({ loading: false });
                }}
              >
                <Label>{fId}</Label>

                <Label>
                  <Icon name='time' /> {saveDateString}
                </Label>

                <div className='float-right'>
                  {email !== null && email !== '' ? emailObj : null}
                </div>
              </a>
            </ListGroup.Item>
          );

          return displayObj;
        }
      });
    }

    return this.state.loading === true ? (
      <Spinner />
    ) : (
      <div>
        <div style={{ height: '400px', overflow: 'scroll' }}>
          <ListGroup>{versionsView}</ListGroup>
        </div>
        {paginationBasic}
      </div>
    );
  }
}

Versions.propTypes = {};

const mapStateToProps = (state) => ({
  project: state.project,
  auth: state.auth,
});

export default connect(mapStateToProps, {
  setTableData,
})(withRouter(Versions));



// WEBPACK FOOTER //
// ./src/components/translations/versions/Versions.js